module.exports = __webpack_public_path__ + "media/images/new/icons/pro-black@2x-4a54880741085547afe4eb7195f5208c.png";